// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterSearch_wrapper__2tqez","label":"FilterSearch_label__3qtAV","input":"FilterSearch_input__2ddVj"};